<!-- Flippable card -->
<ng-container *ngIf="flippable">
  <!-- Front -->
  <div class="ui-card-front">
    <ng-content select="[uiCardFront]"></ng-content>
  </div>

  <!-- Back -->
  <div class="ui-card-back">
    <ng-content select="[uiCardBack]"></ng-content>
  </div>
</ng-container>

<!-- Normal card -->
<ng-container *ngIf="!flippable">
  <!-- Content -->
  <ng-content></ng-content>

  <!-- Expansion -->
  <div class="ui-card-expansion" *ngIf="expanded" [@expandCollapse]>
    <ng-content select="[uiCardExpansion]"></ng-content>
  </div>
</ng-container>
